/**
 * Renders a chat body string with @mentions coloured & bolded.
 *
 * A "mention token" is any @word (unicode letters + digits + underscore).
 * We highlight *all* @tokens rather than only those whose ids are in
 * `mentions` because the token could be shortened (e.g. "@HamzaB") — it
 * still visually communicates "this is a mention" regardless of whether
 * the DB link is present.
 */
export default function MentionText({ text }) {
  if (!text) return null;
  const parts = String(text).split(/(@[\p{L}\p{N}_]{2,})/gu);
  return (
    <>
      {parts.map((chunk, i) =>
        chunk.startsWith("@") ? (
          <span
            key={i}
            className="font-bold text-vertec-blue"
            data-testid="mention-token"
          >
            {chunk}
          </span>
        ) : (
          <span key={i}>{chunk}</span>
        )
      )}
    </>
  );
}
